import React, { useContext } from "react";

// Section for Utilities and Context
import './joblist.css';
import { AuthContext } from "../utils/AuthContext";

// MAIN FUNCTION
export default function JobList(props) {
    const { auth, isAdmin } = useContext(AuthContext);
    const canEdit = isAdmin || auth.user.user_id === props.user_id || (auth.user.contributor && props.user_id === null);

    function companyDivision(position) {
        const organizationName = position.Organization.organization_name;
        const divisionName = position.Division?.division_name ? `, ${position.Division.division_name}` : "";
        const location = `${position.city || position.Division?.city || position.Organization.city}, ${position.state || position.Division?.state || position.Organization.state}`;

        return (
            <div className="position-company">
                {organizationName}
                {divisionName && <i>{divisionName}</i>}
                <div className="row">
                    <div className="col-11">
                        <div className="position-location">{location}</div>
                    </div>
                    {canEdit && (
                        <div className="col-1">
                            <i
                                className="bi bi-pencil-square edit-job-icon"
                                alt="Edit Job Button"
                                data-bs-toggle="modal"
                                data-bs-target="#editJobModal"
                                onClick={() => handleJobEditData(position)}
                            />
                        </div>
                    )}
                </div>
            </div>
        );

    };

    function formatMonthYear(dateString) {
        const date = new Date(dateString);
        const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const month = monthNames[date.getMonth()];
        const year = date.getFullYear();
        return `${month} ${year}`;
    }

    function currentPosition(position) {
        const startDateFormatted = formatMonthYear(position.start_date);
        const endDateEntryFormatted = position.end_date ? formatMonthYear(position.end_date) : 'present';

        return <div className="col-4 position-dates">{startDateFormatted} - {endDateEntryFormatted}</div>
    };

    const handleJobEditData = (position) => {
        for (let i = 0; i < props.experience.length; i++) {
            if (props.experience[i].job_id === position.job_id){
                props.onEditPosition(props.experience[i]);
                return;
            }
        }
    }

    const handleJobHistory = (props) => {
        if(props.experience.length > 0) {
            return (
                props.experience.map((position) => (
                    // Pass user data as props to UserCard component
                        <li className="list-group-item" key={position.job_id}>
                            <div className="row">
                                <div className="col-8 position-title"><b>{position.title}</b></div>
                                {currentPosition(position)}
                            </div>
                            <div className="row">
                                {companyDivision(position)}
                            </div>
                        </li>
                ))
            )
        }

        return <div className="py-2 ms-3">No job history available.</div>

    }

    return (
        <div className="job-list-card profile-overview-card">
            <div className="profile-overview-card-header">
                <span className="profile-overview-card-header-label">
                    <i className="bi bi-briefcase-fill" />
                    Job History
                </span>
                {canEdit && (
                    <i className="bi bi-plus-circle add-job-icon" alt="Add Job Button" data-bs-toggle="modal" data-bs-target="#addJobModal"/>
                )}
            </div>
            <div className="list-group list-group-flush job-list">
                {handleJobHistory(props)}
            </div>
        </div>
    )
}